// Common styles for Pricing component

import { landingButtonGradient } from "../LandingPages/components/LandingUtils";

export const pricingStyles = {
  container: {
    textAlign: 'center',
    marginBottom: '1.5rem',
  },
  titleSection: {
    background: '#e8f7ed',
  },
  badge: {
    fontSize: 24,
    padding: '0 12px',
  },
  mainTitle: {
    fontWeight: 700,
    color: '#222',
    marginBottom: '0.5rem',
  },
  subtitle: {
    fontSize: '18px',
    color: '#555',
  },
  switchRow: {
    margin: '2rem 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
  },
  switchText: (active) => ({
    fontSize: '18px',
    fontWeight: 500,
    color: active ? '#00c853' : '#888',
  }),
  switch: (isYearly) => ({
    backgroundColor: isYearly ? '#00c853' : '#e9e9e9ff',
    width: 48,
    height: 24,
  }),
  card: (plan) => ({
    height: '100%',
    borderRadius: '20px',
    display: 'flex',
    flexDirection: 'column',
    border: plan.recommended ? '2px solid #00c853' : '1px solid #e8e8e8',
    background: '#fff',
    boxShadow: plan.recommended ? '0 8px 24px rgba(0, 200, 83, 0.10)' : '0 4px 12px rgba(0,0,0,0.05)',
    position: 'relative',
  }),
  cardBody: {
    paddingTop: '0.5rem',
  },
  cardCover: {
    textAlign: 'center',
    padding: '1.5rem 1rem 0.5rem 1rem',
  },
  planTitle: {
    color: '#222',
    fontWeight: 600,
    marginBottom: 0,
  },
  planPrice: {
    color: '#00c853',
    marginBottom: 0,
    fontWeight: 700,
    marginTop: '12px',
  },
  planPeriod: {
    fontSize: '16px',
    color: '#8c8c8c',
    fontWeight: 'normal',
    marginLeft: '4px',
  },
  planButton: (plan, hoveredPlan, index) => ({
    height: '46px',
    fontSize: '16px',
    fontWeight: '500',
    borderRadius: '6px',
    background : hoveredPlan === index || plan.recommended ? landingButtonGradient : '',
    // border: plan.recommended && 'none',
    // border:  plan.recommended || hoveredPlan === index ? landingButtonGradient : '',
    // backgroundColor: hoveredPlan === index || plan.recommended ? '#00c853' : '',
    color: hoveredPlan === index || plan.recommended ? '#fff' : '',
    // borderColor: plan.recommended || hoveredPlan === index ? '#00c853' : '',
    boxShadow: plan.recommended ? '0 4px 12px rgba(0, 200, 83, 0.2)' : '',
    transition: 'all 0.3s',
  }),
  featureList: {
    flexGrow: 1,
    marginTop: '1.5rem',
  },
  featureItem: {
    padding: '8px 0',
    borderBottom: 'none',
  },
  featureTag: {
    color: '#00c853',
  },
  featureTagBg: {
    background: '#e8f7ed',
  },
  whySection: {
    background: '#f8fbfc',
    padding: '64px 0 32px 0',
    marginTop: '48px',
  },
  whyContainer: {
    maxWidth: 1100,
    margin: '0 auto',
    textAlign: 'center',
  },
  whyTitle: {
    fontWeight: 700,
    color: '#222',
    marginBottom: '16px',
  },
  whySubtitle: {
    fontSize: '18px',
    color: '#555',
    marginBottom: 32,
    display: 'block',
  },
  whyFeatureIcon: {
    background: '#e8f7ed',
    borderRadius: '50%',
    width: 72,
    height: 72,
    margin: '0 auto 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  whyFeatureTitle: {
    color: '#222',
    fontWeight: 600,
    marginBottom: 8,
  },
  whyFeatureDesc: {
    color: '#555',
  },
  ctaSection: {
    padding: '48px 0 64px 0',
    textAlign: 'center',
  },
  ctaTitle: {
    fontWeight: 700,
    color: '#222',
    marginBottom: '16px',
  },
  ctaSubtitle: {
    fontSize: '18px',
    color: '#555',
    marginBottom: 32,
    display: 'block',
  },
  ctaButton: {
    background: landingButtonGradient,
    border: 'none',
    fontWeight: 600,
    fontSize: 18,
    padding: '0 32px',
    height: 48,
  },
};
